module.exports = __webpack_public_path__ + "static/media/flag.ee48c775.svg";